import AssetsApi from '../routes/asset/assets.api.js';
import findingService from '../routes/finding/v2-service.js';
import tagService from '../routes/tag/service.js';
import userService from '../routes/user/service.svelte.js';
import { translateErrorMessages, flatten422Errors } from './api.svelte.js';
import {removeTags} from '../js/utils.js';
import { notificate } from './notification.js';

let services = {
    asset: AssetsApi,
    finding: findingService,
    tag: tagService,
    user: userService
}

export async function handleMassiveAddition(elements=[], config={elements_type: ""}){
    let results = [];
    let errors = [];
    for(let [idx, element] of Object.entries(elements)){
        try {
            const response = await services[config.elements_type].save(element, [], {massive_addition: true}); // Pause until fetch resolves
            results.push(response);
        }
        catch (error) {
            if(typeof(error.detail) == 'string'){
                errors.push(translateErrorMessages(error.detail, "elements_massive"));
            }
            else {
                // parse API errors
                errors.push(flatten422Errors(error));
            }
        }
    };
    return {results: results, errors: errors};
}

export async function handleMassiveEdition(elements=[], config={elements_type: ""}){
    let results = [];
    let errors = [];
    for(let [idx, element] of Object.entries(elements)){
        try {
            if(config.elements_type == "finding"){
                const response = await services[config.elements_type].patch(element, [], {massive_addition: true, no_toaster: true}, false); // Pause until fetch resolves
                results.push(response);
            }
            else {
                const response = await services[config.elements_type].save(element, [], {massive_addition: true}, false); // Pause until fetch resolves
                results.push(response);
            }
        }
        catch (error) {
            if(typeof(error.detail) == 'string'){
                errors.push(translateErrorMessages(error.detail, "elements_massive"));
            }
            else {
                // parse API errors
                errors.push(flatten422Errors(error));
            }
        }
    };
    return {results: results, errors: errors};
}

export async function handleTagAssociation(elements=[], config={elements_type: ""}){
    let results = [];
    let errors = [];
    for(let [idx, element] of Object.entries(elements)){
        try {
            const response = await tagService.saveAssociation(element, [], {massive_addition: true}, false); // Pause until fetch resolves
            results.push(response);
        }
        catch (error) {
            errors.push(element)
        }
    };
    return {results: results, errors: errors};
}


export default {
    handleMassiveAddition,
    handleMassiveEdition,
    handleTagAssociation
}